// extracted by mini-css-extract-plugin
export default {"stripeFormWrapper":"style_stripeFormWrapper__6QUu4","stripeSubmitButton":"style_stripeSubmitButton__Ex65K"};